enum NotificationsActionTypes {
  CLOSE_NOTIFICATION = 'Notifications/CLOSE_NOTIFICATION ',
  SET_NOTIFICATION = 'Notifications/SET_NOTIFICATION'
}

export default NotificationsActionTypes
